"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeObservabilityTags = void 0;
const serializezObservabilityTag_1 = require("./serializezObservabilityTag");
const serializeObservabilityTags = (tags) => {
    if (!tags) {
        return [];
    }
    return Object.entries(tags).map(([key, value]) => (0, serializezObservabilityTag_1.serializeObservabilityTag)(key, value));
};
exports.serializeObservabilityTags = serializeObservabilityTags;
//# sourceMappingURL=serializeObservabilityTags.js.map